export const baseUrl = `${process.env.REACT_APP_API_URL_SCHEME}://${process.env.REACT_APP_API_URL_SUFFIX}`;

const apiConfig = {
  delivery_provider: {
    subdomain: 'delivery_provider',
    path: '',
  },
};

export default apiConfig;
